// Home page background tints per time of day (see useContextAwareness).
// base:    page background once the hero scrolls away
// about:   About section tint
// section: tint for every section after About
export const TIME_OF_DAY_BACKGROUNDS = {
  night: { base: "#1a0a2e", about: "#1f1a2e", section: "#1a1525" },
  morning: { base: "#2d1f00", about: "#2d2820", section: "#252015" },
  afternoon: { base: "#000000", about: "#252422", section: "#1a1918" },
  evening: { base: "#150a25", about: "#241f2a", section: "#1a1520" },
};
